import { createContext } from 'react';

export interface ResponsiveContextProps {
  xs: boolean;
  gtXs: boolean;
  ltSm: boolean;
  sm: boolean;
  gtSm: boolean;
  ltMd: boolean;
  md: boolean;
  gtMd: boolean;
  ltLg: boolean;
  lg: boolean;
  gtLg: boolean;
  ltXl: boolean;
  xl: boolean;
}

export const responsiveDefaults: ResponsiveContextProps = {
  xs: false,
  gtXs: false,
  ltSm: false,
  sm: false,
  gtSm: false,
  ltMd: false,
  md: false,
  gtMd: false,
  ltLg: false,
  lg: false,
  gtLg: false,
  ltXl: false,
  xl: false,
};

export const ResponsiveContext =
  createContext<ResponsiveContextProps>(responsiveDefaults);
